import React, {Component} from 'react';
import { Field, Fields, reduxForm } from 'redux-form';
import DropDownRenderer from '../helpers/DropDownRenderer';
import Tabs from '../common/form/Tabs';
import RadioButtons from '../common/form/RadioButtons';
import FbgAccessContainer from '../access/FbgAccessContainer';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import Dates from './Dates';

class ChartFilters extends Component {
    constructor(props) {
        super(props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.valid && JSON.stringify(nextProps.formValues) !== JSON.stringify(this.props.formValues)) {
            nextProps.handleSubmit(nextProps.values);
        }
    }

    getEvenTypeOptions() {
        let eventTypes = {
            pageview: {
                value: 'pageview',
                label: <FormattedMessage
                    id="analytics.viewCountTab"
                    defaultMessage="Views count"
                />
            },
            click: {
                value: 'click',
                label: <FormattedMessage
                    id="analytics.clickCountTab"
                    defaultMessage="Clicks count"
                />
            },
        };

        return this.props.eventTypes.map(key => eventTypes[key]);
    }

    render() {
        let {
            handleSubmit,
            companies,
            analyticTypes,
            showAnalyticTypesFilter,
        } = this.props;

        return (
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-12">
                        <Field
                            className="form-control clickable"
                            name="type"
                            component={Tabs}
                            props={{
                                options: this.getEvenTypeOptions()
                            }}
                        />

                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-xl-3 col-lg-5 mb-4">
                        <label className="col-form-label">
                            <b><FormattedMessage
                                id="analytics.dateRangePicker"
                                defaultMessage="Date range"
                            /></b>
                        </label>
                        <Fields
                            type="datePicker"
                            names={['startDate', 'endDate']}
                            component={Dates}
                        />
                    </div>
                    <div className="col-xl-3 col-lg-7 mb-4">
                        <FbgAccessContainer>
                            <div>
                                <label className="col-form-label">
                                    <b><FormattedMessage
                                            id="analytics.companies"
                                            defaultMessage="Corporation"
                                        /></b>
                                </label>
                                <Field
                                    className="form-control clickable"
                                    name="companyId"
                                    component="select"
                                >
                                    {DropDownRenderer.getOptions(companies.data, 'id', 'name')}
                                </Field>
                            </div>
                        </FbgAccessContainer>
                    </div>
                    <div className="col-xl-3 mb-4">
                        {showAnalyticTypesFilter && analyticTypes &&
                            <div>
                                <label className="col-form-label"><b>
                                    <FormattedMessage
                                        id="analytics.analyticType"
                                        defaultMessage="Statistik type"
                                    />
                                </b></label>
                                <Field
                                    className="form-control clickable"
                                    name="analyticType"
                                    component="select"
                                >
                                    {
                                        Object.keys(analyticTypes).map(key => {
                                            return <option key={key} value={key}>{analyticTypes[key].typeName}</option>
                                        })
                                    }
                                </Field>
                            </div>
                        }
                    </div>
                    <div className="col-xl-3">
                        <Field
                            className="form-control clickable"
                            name="groupBy"
                            component={RadioButtons}
                            props={{
                                options: [
                                    {value: 'day', label: <FormattedMessage
                                        id="analytics.dayTab"
                                        defaultMessage="Day"
                                    />},
                                    {value: 'month', label: <FormattedMessage
                                        id="analytics.monthTab"
                                        defaultMessage="Month"
                                    />},
                                ],
                                className: 'pull-right'
                            }}
                        />
                    </div>
                </div>
                <hr/>
            </form>
        );
    }
}

ChartFilters.defaultProps = {
    eventTypes: ['pageview', 'click'],
};

ChartFilters.propTypes = {
    eventTypes: PropTypes.array,
};

ChartFilters = reduxForm({
    form: 'chartFilters'
})(ChartFilters);

export default ChartFilters;


// WEBPACK FOOTER //
// ./web/src/components/charts/ChartFilters.jsx